import { atomWithReset } from 'jotai/utils';

import { SearchCsClinicPageInfo } from './types';

export const searchCsClinicsPageInfoState = atomWithReset<SearchCsClinicPageInfo>({
  categoryKey: null,
  cityCode: null,
  prefectureCode: null,
  query: null,
  page: 1,
  perPage: 4,
  totalPage: 1,
});
